import React from 'react';
import './ToggleSwitch.css';

const ToggleSwitch = ({ isActive, onChange, label = '', disabled = false }) => {
  return (
    <div className="toggle-switch-wrapper">
      {label && <span className="toggle-label">{label}</span>}
      <button
        className={`toggle-switch ${isActive ? 'active' : 'inactive'}`}
        onClick={() => !disabled && onChange(!isActive)}
        disabled={disabled}
        type="button"
        aria-label={`Toggle ${label}`}
      >
        <span className="toggle-slider"></span>
      </button>
    </div>
  );
};

export default ToggleSwitch;
